import dayjs from 'dayjs';
import customParseFormat from 'dayjs/esm/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export default function (o, C, d) {
    d.p.extendedCustomFormatPlugin = true;
    const proto = C.prototype;
    const oldParse = proto.parse;

    proto.parse = function (cfg) {
        return oldParse.call(this, cfg);
    };
}
